import { render, staticRenderFns } from "./ProductGroupCheckBoxGrid-gt3.vue?vue&type=template&id=770f1f85&scoped=true"
import script from "./ProductGroupCheckBoxGrid-gt3.vue?vue&type=script&lang=js"
export * from "./ProductGroupCheckBoxGrid-gt3.vue?vue&type=script&lang=js"
import style0 from "./ProductGroupCheckBoxGrid-gt3.vue?vue&type=style&index=0&id=770f1f85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770f1f85",
  null
  
)

export default component.exports